import React, { useState, useEffect } from "react";
import CityServices from "services/CityServices";
import Select from "react-select";

const SelectSingleCityOnly = ({
  register,
  selectedCity,
  handleCityChange,
  handleCityChangeName,
  name,
  label,
  readonly,
}) => {
  const [cities, setSingleCity] = useState([]);

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: "RRGGBB",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
        ? "rgba(0, 0, 0, 0.15)"
        : "white",
      color: state.isSelected ? "white" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)", // Change the background color on hover
        color: "black", // Change the text color on hover
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: "10px 0 -10px 0", // Add margin to the entire option box
    }),
  };
  useEffect(() => {
    let isMounted = true; // Add this variable to track the component's mounting state

    async function fetchCity() {
      try {
        const response = await CityServices.getAllCity();
        const transformedData = response.data.map((item) => ({
          value: item.id_city,
          label: item.name,
        }));

        // Check if the component is still mounted before updating the state
        if (isMounted) {
          setSingleCity(transformedData);
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    }

    fetchCity();

    // Cleanup function to set isMounted to false when the component is unmounted
    return () => {
      isMounted = false;
    };
  }, []);

  const handleCitySelect = async (selected) => {
    const item = cities.find(
      (item) => String(item.value) === String(selected.value)
    );

    if (item) {
      if (handleCityChange) {
        handleCityChange(selected.value);
      }

      if (handleCityChangeName) {
        handleCityChangeName(selected.label);
      }
    }
  };
  return (
    <Select
      className="dark:text-white-300 leading-5 rounded-md focus:border-white-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300  border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      // isSearchable={false}
      {...register(`${name}`, {
        required: !selectedCity ? `${label} is required!` : false,
      })}
      // defaultValue={selectedCity}
      name={name}
      isDisabled={readonly}
      styles={customSelectStyles}
      options={cities}
      onChange={(e) => handleCitySelect(e)}
      value={
        selectedCity
          ? cities.find(
              (option) =>
                String(option.value) === String(selectedCity) ||
                String(option.label) === String(selectedCity)
            )
          : null
      }
    />
  );
};

export default SelectSingleCityOnly;
